import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query ProjectQuota($projectId: ID!) {
    projectQuota(projectId: $projectId) {
      exceedLimit
    }
  }
`;

export const queryProjectQuota = (projectId) =>
  executeGqlQuery({
    query: QUERY,
    variables: {
      projectId,
    },
  }).then(({ data }) => getSingleProp(data));
